import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { TableRowComponent } from '../tablerow/tablerow.component';
import { MobileTableRowComponent } from '../tablerow/mobiletablerow.component';
import { TableColumnDirective } from '../../service/tablecolumn.directive';
import { RowHeightService } from '../../service/rowheight.service';

@Component({
  selector: 'std-table',
  templateUrl: './table.component.html',
  styles: [
    `
      #table2 ::ng-deep tr:last-child > td:first-child {
        border-bottom-left-radius: 0.5rem !important;
        border-top: 1px solid rgba(11, 14, 66, 0.1) !important;
        border-right: 1px solid rgba(11, 14, 66, 0.1) !important;
        border-bottom: none !important;
        border-left: none !important;
      }

      #table2 ::ng-deep tr:last-child > td:last-child {
        border-bottom-right-radius: 0.5rem !important;
        border-top: 1px solid rgba(11, 14, 66, 0.1) !important;
        border-left: 1px solid rgba(11, 14, 66, 0.1) !important;
        border-bottom: none !important;
        border-right: none !important;
      }

      #table2 ::ng-deep tr:first-child > td:first-child {
        border-top-left-radius: 0.5rem !important;
        border-bottom: 1px solid rgba(11, 14, 66, 0.1) !important;
        border-right: 1px solid rgba(11, 14, 66, 0.1) !important;
        border-top: none !important;
        border-left: none !important;
      }

      #table2 ::ng-deep tr:first-child > td:last-child {
        border-top-right-radius: 0.5rem !important;
        border-bottom: 1px solid rgba(11, 14, 66, 0.1) !important;
        border-left: 1px solid rgba(11, 14, 66, 0.1) !important;
        border-top: none !important;
        border-right: none !important;
      }

      #table2 ::ng-deep thead > tr > th:first-child {
        border-radius: 0.5rem 0px 0px 0.5rem;
        padding-left: 1rem !important;
      }

      #table2 ::ng-deep tr:first-child > td {
        border-top: none;
        border-bottom: 1px solid rgba(11, 14, 66, 0.1);
      }
      #table2 ::ng-deep tr > td {
        border-top: 1px solid rgba(11, 14, 66, 0.1);
        border-right: 1px solid rgba(11, 14, 66, 0.1);
      }
      #table2 ::ng-deep tr > td:last-child {
        border-right: none;
      }
      #table2 ::ng-deep thead > tr > th:last-child {
        border-radius: 0px 0.5rem 0.5rem 0px;
      }

      #table2 ::ng-deep thead > tr {
        border-radius: 0.5rem;
      }

      #table2 ::ng-deep thead {
        position: initial !important;
      }

      #table2 ::ng-deep tbody {
        position: initial !important;
      }
      .head-checkbox {
        padding: 10px 14px;
        border-radius: 8px;
        max-height: 48px;
      }
      .margine-tab {
        margin-right: 10px !important;
      }
      .fake-row {
        width: 100%;
        height: 10px;
        background-color: transparent;
      }
      .check {
        padding: 10px 14px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() containerCheckbox!: string;
  @Input() withHover!: boolean;
  @Input() stripes = false;
  @Input() title!: string;
  @Input() headerClass!: string;
  @Input() bodyClass!: string;
  @Input() checkbox: boolean = false;
  @Input() bgCheckFalse!: string;
  @Input() bgCheckTrue!: string;
  @Input() tableTitle!: string;
  @Input() noDataText = 'No data'
  @Output() rowClick: EventEmitter<any> = new EventEmitter();
  rowHeights!: Observable<number[]>;
  @ContentChildren(TableColumnDirective)
  columns!: QueryList<TableColumnDirective>;
  @ViewChildren(TableRowComponent) rows!: QueryList<TableRowComponent>;
  @ViewChildren(MobileTableRowComponent)
  mobileRows!: QueryList<TableRowComponent>;
  public _data!: Observable<any>;
  mobileItemExpanded = -1;

  constructor(private rowHeightService: RowHeightService) {}
  ngOnInit(): void {
    if (!this.data) {
      this.data = [];
    }
    if (this.data && this.data instanceof Observable) {
      this._data = this.data;
    } else {
      this._data = this.data.length ? of(this.data) : from(this.data);
    }
    this.rowHeightService.rowHeights$.subscribe((heights) => {
      this.rowHeights = this.rowHeightService.rowHeights$;
    });
  }
  @Output() checkboxChange = new EventEmitter<any>();
  @Output() checkboxChangeAll = new EventEmitter<any[]>();
  onCheckboxChange(event: any, item: any) {
    item.checked = event.checked;

    this.checkboxChange.emit({ event: event, item: item });
  }

  onCheckboxChangeAll(event: any) {
    this.data.forEach((item: any) => {
      this.onCheckboxChange(event, item);
    });
    this.checkboxChangeAll.emit(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.data) {
      this.data = [];
    }
    if (this.data && this.data instanceof Observable) {
      this._data = this.data;
    } else {
      this._data = this.data.length ? of(this.data) : from(this.data);
    }
  }

  onRowClick(event: Event, item: any) {
    this.rowClick.emit({ event, item });
  }

  @ViewChildren('row') tableRows!: QueryList<ElementRef>;
}
